import styled from 'styled-components';

import { TextButton } from '@riac/design-system';

export const AuctionSummaryContainer = styled.div`
  color: black;

  > div {
    margin-top: 1em;
    margin-bottom: 0;
  }

  h4 {
    color: black;
  }

  p {
    color: black;
  }
`;

export const PreviewDay = styled.div`
  > header {
    text-decoration: underline;
  }

  > p {
    margin-left: 1em;
  }
`;

export const AuctionSessions = styled.ul`
  list-style: none;
  margin-top: 1em;
`;

export const AuctionSessionContainer = styled.li`
  > header {
    text-decoration: underline;
  }

  > p {
    margin-left: 1em;
  }
`;

export const AuctionExcerpt = styled.div``;

export const ContactInfo = styled.div`
  ${TextButton} {
    color: ${(props) => props.theme.blueLink};
    cursor: pointer;

    &:hover {
      color: ${(props) => props.theme.blueLink};
    }
  }
`;
